import { render, staticRenderFns } from "./MarqueeNotice.vue?vue&type=template&id=6fa2db68&scoped=true"
import script from "./MarqueeNotice.vue?vue&type=script&lang=js"
export * from "./MarqueeNotice.vue?vue&type=script&lang=js"
import style0 from "./MarqueeNotice.vue?vue&type=style&index=0&id=6fa2db68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa2db68",
  null
  
)

export default component.exports